<template>
<div class="chapter">
<div class="inner_page">
<h1 class="heading"><span class="smallcaps">ALSO BY</span><span class="smallcaps"> <br/></span>D<span class="smallcaps">OMENICO </span>S<span class="smallcaps">TARNONE</span></h1>
<p class="center"><em class="italic">Trick</em></p>
<p class="center"><em class="italic">Ties</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// trust_00000.vue?535760df